import { AnyAction, Dispatch } from 'redux';

import { APPOINTMENT_AUTO_BOOK_ERROR } from './ActionTypes';

export type AutoBookingError = 'TIME_TAKEN' | 'DATE_TAKEN' | 'INVALID_SERVICES';

export function setAutoBookingError(error: AutoBookingError) {
  return (dispatch: Dispatch<AnyAction>) => {
    dispatch({
      type: APPOINTMENT_AUTO_BOOK_ERROR,
      payload: error,
    });
  };
}

export function clearAutoBookingError() {
  return (dispatch: Dispatch<AnyAction>) => {
    dispatch({
      type: APPOINTMENT_AUTO_BOOK_ERROR,
      payload: null,
    });
  };
}
